// @flow
import * as React from 'react';
import { withTheme } from 'styled-components';
import SelectField from 'material-ui/SelectField/SelectField';
import MenuItem from 'material-ui/MenuItem/MenuItem';
import FilterIcon from 'material-ui/svg-icons/content/filter-list';

function retrieveFilterValues(filters: Array<Object>) {
  return filters.reduce((result, filter) => {
    if (filter.selected) {
      result.push(filter.value);
    }
    return result;
  }, []);
}

type Props = {
  theme: Object,
  filters: Array<Object>,
  selectionRenderer: (filters: any) => string,
  onFiltersChange: (filters: any) => void,
};

function SelectFilter({ filters, onFiltersChange, selectionRenderer, theme }: Props) {
  const filterValues = retrieveFilterValues(filters);

  return (
    <SelectField
      multiple
      value={filterValues}
      onChange={(e, i, values: any) => onFiltersChange(values)}
      selectionRenderer={v => selectionRenderer(v)}
      dropDownMenuProps={{ iconButton: <FilterIcon /> }}
      underlineStyle={{ display: 'none' }}
      labelStyle={{
        color: theme.colors.primaryText,
        fontSize: '1rem',
        paddingLeft: theme.metrics.margin,
        paddingRight: theme.metrics.margin,
      }}
      menuItemStyle={{
        color: theme.colors.primaryText,
        fontSize: '1rem',
      }}
      fullWidth
    >
      {filters.map(filter =>
        <MenuItem
          key={filter.value}
          checked={filter.selected}
          value={filter.value}
          primaryText={filter.text}
        />,
      )}
    </SelectField>
  );
}

export default withTheme(SelectFilter);



// WEBPACK FOOTER //
// ./src/common/components/SelectFilter.js